<div
  class="flex flex-col gap-4 rounded-[8px] p-4 box-border w-full bg-neutrals-0 border-neutrals-500"
>
  <div class="flex justify-between items-center">
    <ui-paragraph
      type="p12"
      mobile-type="p12"
      font-weight="semibold"
      text-color="neutrals-700"
    >
      Tasa de conversión
    </ui-paragraph>
    <unicon-menu-tooltip>
      <div menuTooltipContent class="flex flex-col gap-3">
        <ui-paragraph
          type="p14"
          mobile-type="p14"
          font-weight="semibold"
          text-color="neutrals-900"
        >
          Tasa de conversión
        </ui-paragraph>
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          font-weight="regular"
          text-color="neutrals-900"
        >
          Número de conversiones
          <br />
          (clientes en pagado)
          <br />
          <br />
          __________________ x 100
          <br />
          <br />
          Número total de usuarios
          <br />
          (clientes en sin asignar)
        </ui-paragraph>
      </div>
    </unicon-menu-tooltip>
  </div>
  <div class="flex flex-col justify-center items-center box-border">
    <ui-headline
      type="h64"
      mobile-type="h64"
      font-weight="semibold"
      text-color="neutrals-900"
    >
      47%
    </ui-headline>
    <unicon-percent-indicator
      class="flex-none"
      [positive]="true"
      [percent]="12"
    />
  </div>
  <div class="flex flex-col gap-2">
    <ui-paragraph
      type="p10"
      mobile-type="p10"
      font-weight="regular"
      text-color="neutrals-700"
    >
      Meta xxxx
    </ui-paragraph>

    <div class="w-full h-3 rounded-[4px] min-h-3 bg-neutrals-300">
      <div class="w-[72%] h-3 rounded-[4px] min-h-3 bg-neutrals-900"></div>
    </div>

    <div class="flex flex-row justify-between">
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        font-weight="bold"
        text-color="neutrals-900"
      >
        72%
      </ui-paragraph>
      <ui-paragraph
        type="p10"
        mobile-type="p10"
        font-weight="bold"
        text-color="neutrals-500"
      >
        94k
      </ui-paragraph>
    </div>
  </div>
</div>
